export const GLOBAL_API =
  process.env.REACT_APP_GLOBAL_API ||
  "https://crowdappstechnologies.in/nodeapi/ec-card-gateway/api";

export const APP_VERSION = "2.0.0";
export const GLOBAL_LOADER = "GLOBAL_LOADER";
export const GLOBAL_ALERT = "GLOBAL_ALERT";
export const REGISTRAION_CONDITIONAL_AGE = 25;
export const GLOBAL_ALERT_REMOVE = "GLOBAL_ALERT_REMOVE";
export const GLOBAL_API_DATA = "GLOBAL_API_DATA";
export const USER_MSG_COUNT = "USER_MSG_COUNT";
export const IP_KEY = process.env.REACT_APP_IP_KEY || "";
export const GOOGLE_MAPS_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";
export const VAPID_KEY = process.env.REACT_APP_VAPID_KEY || "";

export const GENDER_LIST = [
  {
    id: "btnMale",
    value: "male",
    text: "user.register.genderMale",
  },
  {
    id: "btnFemale",
    value: "female",
    text: "user.register.genderFemale",
  },
  {
    id: "btnNonBinary",
    value: "non-binary",
    text: "user.register.genderNonBinary",
  },
  {
    id: "btnOther",
    value: "others",
    text: "user.register.genderOther",
  },
  {
    id: "btnUnspecified",
    value: "not_disclosed",
    text: "user.register.genderNotDisclosed",
  },
];

export const MAP_SHOW_LIST = [
  {
    id: "both",
    value: "all",
    text: "common.all",
  },

  {
    id: "yes",
    value: "yes",
    text: "common.yes",
  },
  {
    id: "no",
    value: "no",
    text: "common.no",
  },
];

export const PAGE_ENTRY_SIZE = [
  { value: 25 },
  { value: 50 },
  { value: 75 },
  { value: 100 },
];

export const ADMIN_SIDEBAR = [
  {
    text: "admin.sidebar.manageUsers",
    link: "manage-users",
    icon: "fas fa-users",
  },
  {
    text: "admin.sidebar.manageVenue",
    icon: "fas fa-book",
    value: "manageVenue",
    subMenu: [
      {
        text: "admin.sidebar.manageStores",
        link: "manage-stores",
        icon: "fas fa-home",
        value: "manage-stores",
      },
      {
        text: "admin.sidebar.manageKiosk",
        link: "manage-kiosk",
        icon: "fas fa-home",
        value: "manage-kiosk",
      },
      {
        text: "admin.sidebar.productCatalogue",
        link: "manage-product-catalouge",
        icon: "fas fa-home",
        value: "manage-product-catalouge",
      },
      {
        text: "admin.sidebar.manageOnlineStore",
        link: "manage-online-store",
        icon: "fas fa-home",
        value: "manage-online-store",
      },
      {
        text: "admin.sidebar.physicalCards",
        link: "physical-cards",
        icon: "fas fa-id-card",
        value: "physical-cards",
        featureGate: "physicalCard",
      },
    ],
  },
  {
    text: "admin.sidebar.manageAccessCodes",
    link: "access-codes",
    icon: "fas fa-address-card",
  },
  {
    text: "admin.sidebar.quizVideos",
    link: "quiz-videos",
    icon: "fas fa-video",
  },
  {
    text: "admin.sidebar.quizQuestions",
    link: "quiz",
    icon: "fas fa-question",
  },
  {
    text: "admin.sidebar.manageAdmins",
    link: "manage-admins",
    icon: "fas fa-users-cog",
  },

  {
    text: "admin.sidebar.manageEducation",
    link: "education-management",
    icon: "fas fa-book",
  },
  {
    text: "admin.sidebar.manageNotifications",
    link: "notification-management",
    icon: "fas fa-book",
  },
  {
    text: "admin.sidebar.reports",
    icon: "fas fa-book",
    value: "reports",
    subMenu: [
      {
        text: "admin.sidebar.venuesReport",
        link: "venues-report",
        icon: "fas fa-book",
        value: "stores-report",
      },
      {
        text: "admin.sidebar.usersReport",
        link: "users-report",
        icon: "fas fa-book",
        value: "users-report",
      },
      {
        text: "admin.sidebar.usersDataReport",
        link: "users-data-report",
        icon: "fas fa-book",
        value: "users-data-report",
      },
      {
        text: "admin.sidebar.physicalCardsReport",
        link: "physical-cards-report",
        icon: "fas fa-id-card",
        value: "physical-cards-report",
        featureGate: "physicalCard",
      },
    ],
  },

  {
    text: "admin.sidebar.support",
    link: "support",
    icon: "fas fa-book",
  },
  {
    text: "admin.sidebar.configuration",
    link: "manage-configuration",
    icon: "fas fa-book",
  },
  {
    text: "admin.sidebar.eshsLearning",
    icon: "fas fa-graduation-cap",
    value: "lms",
    featureGate: "lms",
    subMenu: [
      {
        text: "admin.sidebar.lmsOverview",
        link: "lms/overview",
        icon: "fas fa-chart-line",
        value: "lms-overview",
      },
      {
        text: "admin.sidebar.lmsCourses",
        link: "lms/courses",
        icon: "fas fa-book-open",
        value: "lms-courses",
      },
      {
        text: "admin.sidebar.lmsLearners",
        link: "lms/learners",
        icon: "fas fa-user-graduate",
        value: "lms-learners",
      },
      // {
      //   text: "admin.sidebar.lmsRegistrations",
      //   link: "lms/registrations",
      //   icon: "fas fa-user-plus",
      //   value: "lms-registrations",
      // },
      {
        text: "admin.sidebar.lmsNewsletter",
        link: "lms/newsletter",
        icon: "fas fa-envelope-open-text",
        value: "lms-newsletter",
      },
      {
        text: "admin.sidebar.lmsSettings",
        link: "lms/settings",
        icon: "fas fa-sliders-h",
        value: "lms-settings",
      },
    ],
  },
];

export const SUPERADMIN_SIDEBAR = [
  {
    text: "superadmin.sidebar.manageOrganisations",
    link: "manage-organisations",
    icon: "fas fa-building",
  },
  {
    text: "superadmin.sidebar.manageAdmin",
    link: "manage-admin",
    icon: "fas fa-users-cog",
  },
  {
    text: "superadmin.sidebar.manageSuperAdmin",
    link: "manage-superadmin",
    icon: "fas fa-user-shield",
  },
];

export const UPLOAD_IMAGE = "../assets/wallpaper/upload-image.png";

export const ORG_DETAILS = "ORG_DETAILS";
export const ADD_ORG_NAME = "ADD_ORG_NAME";

export const STORES_DROPDOWN_LIST = [
  {
    label: "common.all",
    value: "all",
  },
  {
    label: "common.stores",
    value: "stores",
  },
  {
    label: "common.kiosk",
    value: "ivts",
  },
  {
    label: "common.online",
    value: "online",
  },
];

export const ZONES_LIST = [
  {
    label: "common.all",
    value: "all",
  },
  {
    label: "common.stores",
    value: "stores",
  },
  {
    label: "common.kiosk",
    value: "ivts",
  },
  {
    label: "common.online",
    value: "online",
  },
];

export const TERMSMODALCONTENT = {
  heading: "user.termsModal.heading",
  body: "user.termsModal.body",
};

export const MANAGESTOCKTYPES = {
  MANAGESTOCKS: "common.manageStocks",
  STOCKTRANSACTIONS: "common.stockTransactions",
};

export const addProductBtnHeight = "56px";
